package pl.michal_cyran.portfolio

import com.varabyte.kobweb.compose.css.Background
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.silk.init.InitSilk
import com.varabyte.kobweb.silk.init.InitSilkContext
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import com.varabyte.kobweb.silk.theme.colors.palette.background
import com.varabyte.kobweb.silk.theme.colors.palette.color
import org.jetbrains.compose.web.css.CSSColorValue
import pl.michal_cyran.portfolio.colors.CyanColors
import pl.michal_cyran.portfolio.colors.Dark
import pl.michal_cyran.portfolio.colors.Light

/**
 * @property nearBackground A useful color to apply to a container that should differentiate itself from the background
 *   but just a little.
 */
class SitePalette(
    val nearBackground: Color,
    val cobweb: Color,
    val brand: Brand,
    val background: CSSColorValue,
    val surface: CSSColorValue,
    val surfaceContainer: CSSColorValue,
    val secondaryContainer: CSSColorValue,
) {
    class Brand(
        val primary: Color = Color.rgb(0x3C83EF),
        val accent: Color = Color.rgb(0xF3DB5B),
    )
}

object SitePalettes {
    val light = SitePalette(

        nearBackground = Color.rgb(0xF4F6FA),
        cobweb = Colors.LightGray,
        brand = SitePalette.Brand(
            primary = Color.rgb(0x3C83EF),
            accent = Color.rgb(0xFCBA03),
        ),
        background = Light.surface,
        surface = Light.surface,
        surfaceContainer = Color.rgb(0xF4F6FA),
        secondaryContainer = Color.rgb(r = 232, g = 222, b = 248)
    )
    val dark = SitePalette(
        nearBackground = Color.rgb(0xFFF),
        cobweb = Colors.LightGray.inverted(),
        brand = SitePalette.Brand(
            primary = Color.rgb(0x3C83EF),
            accent = Color.rgb(0xF3DB5B),
        ),
        background = Dark.background,
        surface = Dark.surface,
        surfaceContainer = Dark.surfaceContainer,
        secondaryContainer = CyanColors.Cyan900.copy(alpha = 60),
    )
}

fun ColorMode.toSitePalette(): SitePalette {
    return when (this) {
        ColorMode.LIGHT -> SitePalettes.light
        ColorMode.DARK -> SitePalettes.dark
    }
}

@InitSilk
fun initTheme(ctx: InitSilkContext) {
    ctx.theme.palettes.light.background = Color.rgb(0xFAFAFA)
    ctx.theme.palettes.light.color = Colors.Black
    ctx.theme.palettes.dark.background = Color.rgb(0x06080B)
    ctx.theme.palettes.dark.color = Colors.White
}
